<template>
  <div class="store-one-step">
    <a-form :form="form" @submit="handleSubmit">
      <a-form-item label="场地名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input
          placeholder="请输入"
          :disabled="oneDisable"
          v-decorator="['name',{rules: [{required: true, message: '请输入场地名称',}]}]"
        ></a-input>
      </a-form-item>
      <a-form-item label="场地英文名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input
          placeholder="请输入"
          :disabled="oneDisable"
          v-decorator="['englishName',{rules: [{message: '请输入场地英文名称', whitespace: true }]}]"
        ></a-input>
      </a-form-item>
      <a-form-item label="场地所在城市" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-cascader
          :allowClear="false"
          :options="optionsArea"
          @change="onChangeCity"
          placeholder="请选择"
          :disabled="oneDisable"
          v-decorator="['cityList',{rules: [{type: 'array', required: true, message: '请输入场地所在城市',}]}]"
        />
      </a-form-item>
      
      <a-form-item label="场地详细地址" :labelCol="labelCol" :wrapperCol="wrapperCol" class="maprow">
        <a-input
          placeholder="请输入"
          :disabled="oneDisable"
          v-decorator="['address',{rules: [{required: true, message: '请输入场地详细地址',}]}]"
        ></a-input>
        <!-- <a-select
          showSearch
          style="width: 100%"
          placeholder="请输入"
          :disabled="oneDisable"
          @search="inputChange"
          v-decorator="['address',{rules: [{required: true, message: '请输入场地详细地址',}]}]"
        >
            <a-button slot="suffixIcon" class="mapbtn" type="primary" @click="searchKeyword">搜索</a-button>
            <a-select-option v-for="(item,index) in searchResultsLocation"  :key="index"  @click="searchChecked(item)" >{{item.name}}</a-select-option>
        </a-select> -->
      </a-form-item>
      <a-form-item label="场地详细地址(英文)" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input
          placeholder="请输入"
          :disabled="oneDisable"
          v-decorator="['englishAddress',{rules: [{message: '请输入场地详细地址(英文)', whitespace: true }]}]"
        ></a-input>
      </a-form-item>
      <a-form-item label=" " :colon="false" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <!-- 地图组件 -->
        <t-map-component
          ref="locationVal"
          :disabled="oneDisable"
          :selectedCity="selectedCity"
          @location="getLocation"
        ></t-map-component>
      </a-form-item>
      <a-form-item label="场地经纬度" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-group compact >
              <a-input class="age-input age-input-left" placeholder="地图选址后自动填入经度" :disabled="oneDisable" v-decorator="['longitude',{rules: [{required: true, message: '请通过地图搜索后自动填入经度',}]}]" />
              <a-input style="width: 60px; border-left: 0; pointer-events: none; backgroundColor: #fff" placeholder="，" disabled />
              <a-input class="age-input age-input-right" placeholder="地图选址后自动填入纬度" :disabled="oneDisable" v-decorator="['latitude',{rules: [{required: true, message: '请通过地图搜索后自动填入纬度',}]}]" />
          </a-input-group>
      </a-form-item>
      <a-form-item label="场地电话" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input
          placeholder="请输入"
          :disabled="oneDisable"
          v-decorator="['phone',{rules: [{required: true, message: '请输入场地电话',}]}]"
        ></a-input>
      </a-form-item>
      <a-form-item label="场地容量" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input
          placeholder="请输入数量"
          addonAfter="/家庭"
          :disabled="oneDisable"
          v-decorator="['capacity',{rules: [{required: true, message: '请输入场地容量',}]}]"
        ></a-input>
      </a-form-item>
      <a-form-item label="场地营业时间" :labelCol="labelCol" :wrapperCol="wrapperCol" :required="true">
        <div class="card-gray" v-for="(k) in form.getFieldValue('keys')" :key="k">
          <a-checkbox-group
            :options="plainOptions"
            :disabled="oneDisable || plainOptions.disabled"
            v-decorator="[`weekdayList${k}`]"
          />
          <div>
            <!-- 时间级联 -->
            时间范围：
            <a-time-picker
              format="HH:mm"
              :disabled="oneDisable || plainOptions.disabled"
              :id="`startTime${k}`"
              v-decorator="[`startTime${k}`]"
            ></a-time-picker> ~
            <a-time-picker
              format="HH:mm"
              :disabled="oneDisable || plainOptions.disabled"
              :id="`endTime${k}`"
              v-decorator="[`endTime${k}`]"
            ></a-time-picker>
          </div>
          <div class="text-position" v-if="!oneDisable">
            <a class="text-primary" @click="addTime(k)" >新增</a>
            <a-divider type="vertical" v-if="form.getFieldValue('keys').length > 1"/>
            <a
              class="text-primary"
              @click="()=>removeTime(k)"
              v-if="form.getFieldValue('keys').length > 1"
            >删除</a>
          </div>
        </div>
      </a-form-item>
      <a-form-item label="场地营业时间备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-textarea
          placeholder="请输入"
          :disabled="oneDisable"
          v-decorator="['description']"
          :maxLength="100"
        ></a-textarea>
      </a-form-item>
      <a-form-item label="场地状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-radio-group
          name="radioGroup"
          option.initialValue="1"
          v-decorator="['state',{initialValue:1}]"
          :disabled="oneDisable"
        >
          <a-radio :value="1">正常营业</a-radio>
          <a-radio :value="0">停止营业</a-radio>
          <a-radio :value="2">即将开业</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item class="text-center" v-if="showOneBtn">
        <a-button @click="backPage">返回</a-button>
        <a-button type="primary" html-type="submit">下一步</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>

    /**
     * 场地信息组件
     * @prop {Boolean} oneDisable 禁用所有表单项，第四步和查看详情时为true
     * @prop {Boolean} showOneBtn 第四步时控制操作按钮是否展示
     * @prop {Object} allData 编辑和查看详情时获取所有接口数据
     *
     */
import moment  from 'moment';
import timePicker from "@/components/common/timePickerCascader";
import TMapComponent from "@/components/common/tMap.component";
import optionsArea from "@/assets/static/area.json"; //加载本地数据文件
export default {
	name: "newStepOne",
	zh: "场地信息组件",
	data() {
		return {
			labelCol: {span: 7},
			wrapperCol: {span: 11},
			optionsArea,
			cityName: "",
			timeNum: 1,
			plainOptions: [
				{ label: "周一", value: 1, disabled: false },
				{ label: "周二", value: 2, disabled: false },
				{ label: "周三", value: 3, disabled: false },
				{ label: "周四", value: 4, disabled: false },
				{ label: "周五", value: 5, disabled: false },
				{ label: "周六", value: 6, disabled: false },
				{ label: "周日", value: 7, disabled: false }
			],
			longitudeVal: 120.15,
			latitudeVal: 30.26,
			workTime: [],
			area: '',
			addressToMap: '',

			selectedCity: null,
		};
	},
	props: {
		oneDisable: { type: Boolean },
		showOneBtn: { type: Boolean },
		allData: { type: Object },
	},
	components: {
		timePicker,
		TMapComponent
	},
	methods: {
		// 当点击下一步时将第一步的全部内容传给父组件 同时隐藏第一步 显示第二步
		handleSubmit(e) {
		let _this = this;
		e.preventDefault();
		_this.form.validateFields((err, values) => {
			if (!err) {
			const keys = this.form.getFieldValue("keys");
			let weekdayList = [] // 保存所有已选的营业日期
			_this.workTime = []
			for (let index = 0; index < keys.length; index++) {
				let i = keys[index]
				weekdayList = weekdayList.concat(values["weekdayList" + i])
				if(!values["startTime" + i] || !values["endTime" + i] || values["weekdayList" + i].length == 0) {
				this.$message.error('请选择场地营业时间')
				return false
				}
				if(values["endTime" + i]-values["startTime" + i] <= 0 ) {
				this.$message.error('结束时间必须大于开始时间')
				return false
				}
				_this.workTime.push({
				startTime: values["startTime" + i] && values["startTime" + i].format("HH:mm"),
				endTime: values["endTime" + i] && values["endTime" + i].format("HH:mm"),
				weekdayList: values["weekdayList" + i]
				})
			}
			// 判断所有已选日期组成的数组中是否有重复
			let hash = {}
			for(let i in weekdayList) {
				if(hash[weekdayList[i]]) {
				this.$message.error('场地营业日期不能重复')
				return true
				}
				hash[weekdayList[i]] = true
			}
			
			_this.longitude = values.longitude;
			_this.latitude = values.latitude;
				_this.area = this.findAddrByCode(values.cityList).join('')
			_this.$emit("stepOneData", {
				current: 1,
				oneDisable: true,
				showOneBtn: false,
				name: values.name,
				englishName: values.englishName,
				englishAddress: values.englishAddress,
				areaCode: values.cityList[2],
				city: _this.cityName,
				area: _this.area,
				address: values.address,
				longitude: this.longitude,
				latitude: this.latitude,
				phone: values.phone,
				capacity: values.capacity,
				state: values.state,
				workTime: _this.workTime,
				description: values.description,
			});
			}
		});
		},
		// 获取时间地图子组件的经纬度
		getLocation(val) {
			this.longitudeVal = val.lat;
			this.latitudeVal = val.lng;
			this.form.setFieldsValue({
				longitude: val.lng,
				latitude: val.lat
			});
		},
		//通过地址编码获取地址名
		findAddrByCode(codeArr) {
			let curSearchObj = this.optionsArea
			let result = []
			for (let i = 0; i < codeArr.length; i++) {
				for (var j = 0; j < curSearchObj.length; j++) {
					if (curSearchObj[j]['value'] === codeArr[i]) {
						result.push(curSearchObj[j]['label'])
						curSearchObj = curSearchObj[j]['children']
						break
					}
				}
			}
			return result
		},
		onChangeCity(value, selectedOptions) {
			this.form.setFieldsValue({
				address: null,
			});
				var provinceLength=selectedOptions[0].label.split('').length
				//判断第一个选项是否为市
			if(selectedOptions[0].label.split('')[provinceLength-1]=='市'){
				this.selectedCity=selectedOptions[0].label
			}else{
				this.selectedCity=selectedOptions[1].label
			}
			this.cityName = selectedOptions[1].label == "市辖区" ? selectedOptions[0].label : selectedOptions[1].label
			if(selectedOptions[1].label == "市辖区") {
				this.cityName = selectedOptions[0].label
				this.area = selectedOptions[0].label + selectedOptions[2].label
			}else {
				this.cityName = selectedOptions[1].label
				this.area = selectedOptions[0].label + this.cityName + selectedOptions[2].label
			}
			this.addressToMap = this.cityName + this.area
		},
		backPage() {
			this.$router.push({ name: "sitePages" });
		},
		// 新增营业时间段
		addTime(k) {
			const { form } = this;
			const keys = form.getFieldValue("keys");
			const nextWeekdayList = keys.concat(++this.timeNum);
			form.setFieldsValue({
				keys: nextWeekdayList
			});
		},
		// 删除营业时间段 当已有时间段个数>1时
		removeTime(k) {
			const { form } = this;
			const keys = form.getFieldValue("keys");

			form.setFieldsValue({
				keys: keys.filter(key => key !== k),
			})
		}
	},
	beforeCreate() {
		this.form = this.$form.createForm(this);
		this.form.getFieldDecorator("keys", {
		initialValue: ["1"],
		preserve: true
		});
	},
	created() {},
	updated() {},
	mounted() {},
	computed: {},
	watch: {
		'allData'(value) {
			let newValue = this.$utils.deepClone(value)
			this.cityName = newValue.city;
			this.longitudeVal = newValue.longitude;
			this.latitudeVal = newValue.latitude;
			let valuesForm = {
				address: newValue.address,
				capacity: newValue.capacity,
				cityList: newValue.cityList,
				name: newValue.name,
				englishName: newValue.englishName,
				englishAddress: newValue.englishAddress,
				phone: newValue.phone,
				state: newValue.state,
				description: newValue.description,
			}
			valuesForm.cityList = new Array(3);
			valuesForm.cityList[2] = newValue.areaCode;
			valuesForm.cityList[1] = newValue.areaCode.substr(0,4)+'00';
			valuesForm.cityList[0] = newValue.areaCode.substr(0,2)+'0000';
			try {
				newValue.workTime = JSON.parse(newValue.workTime);
			} catch (error) {
				// console.error(error);
			}
			if(Array.isArray(newValue.workTime)) {
				newValue.workTime.map((item,i) => {
					let k = i + 1;
					this.timeNum = k;
					k < newValue.workTime.length && this.addTime();
					let startTime = 'startTime' + k;
					let endTime = 'endTime' + k;
					let weekdayList = 'weekdayList' + k;
					valuesForm[startTime] = moment(item.startTime,'HH:mm');
					valuesForm[endTime] = moment(item.endTime,'HH:mm');
					valuesForm[weekdayList] = item.weekdayList;
				})
			}
			//地图标记
			setTimeout(()=>{
				if (this.$refs && this.$refs.locationVal) {
					this.$refs.locationVal.searchChecked(new qq.maps.LatLng(newValue.latitude,newValue.longitude));
				}
			},1500)
			this.$nextTick(() => {
				this.form.setFieldsValue(valuesForm);
			})
		},
	}
};
</script>

<style lang="scss">
.store-one-step {
  .ant-input-number {
    width: calc(50% - 4px);
  }
    .age-input {
        width: calc(50% - 30px);
        text-align: center;
        &-right {
            border-left: 0;
        }
    }
  .ant-time-picker {
    width: calc(50% - 50px);
  }
  .maprow {
    position: relative;
    .mapbtn {
      position: absolute;
      right: -12px;
      top: -10px;
    }
  }
}
.card-gray {
  padding: 8px;
  margin-bottom: 8px;
  background: rgba(250, 250, 250, 1);
  border-radius: 4px;
  border: 1px solid rgba(233, 233, 233, 1);
  position: relative;
  .ant-select {
    margin-bottom: 16px;
  }
  .text-position {
    position: absolute;
    right: -88px;
    bottom: 8px;
  }
}
</style>
